import React from 'react';
import PropTypes from 'prop-types';
import svgSprite from '@images/icons/__svgsprite.svg';

const SvgIconUse = ({ id, ...props }) => (
  <svg id={id} data-testid="svg-icon" {...props}>
    <use href={`${svgSprite}#${id}`} />
  </svg>
);

SvgIconUse.propTypes = {
  id: PropTypes.string.isRequired,
};

export default SvgIconUse;
